import { Answer } from '../redux/Slices/InterviewSlice/types';

import api from './api';

export const interviewApi = api.injectEndpoints({
  endpoints: builder => ({
    sendOtp: builder.mutation({
      query: payload => ({
        url: '/api/auth/request/otp',
        method: 'POST',
        body: payload
      })
    }),
    getAvatars: builder.query({
      query: () => ({
        url: '/api/interview/voice/getall',
        method: 'GET'
      })
    }),
    getTopic: builder.query({
      query: () => ({
        url: '/api/interview/topic/getall',
        method: 'GET'
      })
    }),
    generateTest: builder.mutation({
      query: ({ topicId, companyId, questionDifficulty }) => ({
        url: '/api/interview/test/generate/test',
        method: 'POST',
        params: {
          topicId,
          companyId,
          questionDifficulty
        }
      })
    }),
    submitAnswer: builder.mutation({
      query: ({ userTestId, body }: { userTestId: string; body: Answer }) => ({
        url: '/api/interview/usertest/submit/answer',
        method: 'PUT',
        body,
        params: {
          userTestId
        }
      })
    }),
    interviewEndTest: builder.mutation({
      query: userTestId => ({
        url: '/api/interview/usertest/end/test',
        method: 'PUT',
        params: {
          userTestId
        }
      })
    })
  })
});

export const {
  useSendOtpMutation,
  useGetAvatarsQuery,
  useGetTopicQuery,
  useGenerateTestMutation,
  useSubmitAnswerMutation,
  useInterviewEndTestMutation
} = interviewApi;
